<app-loader></app-loader>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="table-card manager-profile">
    <div class="table-top ">
        <h3 class="sub-text">Profile</h3>
        <form [formGroup]="managerForm" (ngSubmit)="submit()">

            <div class="light-bg">
                <div class="uploadImageOuter cstom-manager">
                    <img [src]="imageUrl || dummy" alt="Preview" class="preview-image"
                        formControlName="profileImagePath">
                    <div class="upload-remove">
                        <h5 *ngIf="imageUrl"><a (click)="clearImage()">Remove</a></h5>
                    </div>
                    <div class="editImage">
                        <input type="file" (change)="onImageSelected($event)" accept="image/*" id="imageInput"
                            style="opacity: 0;">
                        <em class="pi pi-pencil" for="imageInput" style="font-size: .8rem; color: #fff;"></em>
                    </div>
                    <div *ngIf="isProfileImgError">
                        <div class="validation-error">File size should be less than 5MB.</div>
                    </div>
                </div>
            </div>

            <div class="grid form-deatail">
                <div class="col-12 lg:col-6 custom-spacing-right multiselect">
                    <div class="flex flex-column formgrid">
                        <label for="firstName">First Name<span class="custom-star">*</span></label>
                        <input pInputText placeholder="Enter First Name" id="firstName" maxlength="50"
                            aria-describedby="username-help" formControlName="name"
                            (keydown)="dialogControlService.noNumbersValidator($event)" />
                        <div
                            *ngIf="managerForm.get('name')?.hasError('required')  && (managerForm.get('name')?.dirty || managerForm.get('name')?.touched)">
                            <div class="validation-error"> This field is required*</div>
                        </div>
                        <div
                            *ngIf="managerForm.get('name')?.hasError('minlength')  && (managerForm.get('name')?.dirty || managerForm.get('name')?.touched)">
                            <div class="validation-error"> Minimum 3 letters are required*</div>
                        </div>
                        <div
                            *ngIf="managerForm.get('name')?.hasError('maxlength')  && (managerForm.get('name')?.dirty || managerForm.get('name')?.touched)">
                            <div class="validation-error"> Maximum 50 letters are required*</div>
                        </div>
                        <div
                            *ngIf="managerForm.get('name')?.hasError('pattern')  && (managerForm.get('name')?.dirty || managerForm.get('name')?.touched)">
                            <div class="validation-error"> Please enter only letters*</div>
                        </div>
                        <div
                            *ngIf="managerForm.get('name')?.hasError('leadingSpace')  && (managerForm.get('name')?.dirty || managerForm.get('name')?.touched)">
                            <div class="validation-error">First Name cannot start with a space.*</div>
                        </div>
                    </div>
                    <div class="flex flex-column formgrid">
                        <label htmlFor="email">Email<span class="custom-star">*</span></label>
                        <input pInputText placeholder="Enter Email" id="email" aria-describedby="username-help"
                            formControlName="email" />
                        <div
                            *ngIf="managerForm.get('email')?.hasError('required') && (managerForm.get('email')?.dirty || managerForm.get('email')?.touched)">
                            <div class="validation-error"> This field is required*</div>
                        </div>
                        <div
                            *ngIf="managerForm.get('email')?.hasError('pattern') && (managerForm.get('email')?.dirty || managerForm.get('email')?.touched)">
                            <div class="validation-error">Enter a valid Email*</div>
                        </div>
                    </div>

                    <div class="flex flex-column formgrid country-code">
                        <label htmlFor="phone">Mobile Number<span class="custom-star">*</span></label>
                        <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="preferredCountries"
                            [disabled]="true" [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
                            [searchCountryFlag]="true"
                            [searchCountryField]="[searchCountryField.Iso2, searchCountryField.Name]"
                            [selectFirstCountry]="false" [selectedCountryISO]="countryISO" [maxLength]="10"
                            customPlaceholder="Enter Mobile Number"
                            [phoneValidation]="true" [separateDialCode]="separateDialCode"
                            [numberFormat]="phoneNumberFormat.National" name="phone" formControlName="phone">
                        </ngx-intl-tel-input>
                        <div
                            *ngIf="managerForm.get('phone').hasError('required') && managerForm.get('phone').dirty && managerForm.get('phone').touched">
                            <small class="validation-error">This field is required*</small>
                        </div>
                        <div
                            *ngIf="!managerForm.get('phone').hasError('required') && managerForm.get('phone').touched && managerForm.get('phone').invalid">
                            <small class="validation-error">Mobile Number is not valid*</small>
                        </div>
                    </div>

                    <div class="flex flex-column formgrid">
                        <label htmlFor="parkingLotId">Select Parking Lot<span class="custom-star">*</span></label>
                        <p-multiSelect [options]="parkingLotByStates" formControlName="parkingLotId"
                            defaultLabel="Select Parking Lot" optionLabel="name" optionValue="id"
                            class="multiselect-custom" (onChange)="assignedParkingLots($event)">

                        </p-multiSelect>

                        <div class="validation-error"
                            *ngIf="managerForm.get('parkingLotId')?.hasError('required') && (managerForm.get('parkingLotId')?.dirty || managerForm.get('parkingLotId')?.touched)">
                            <div class="validation-error">Field is required*</div>
                        </div>
                    </div>

                </div>
                <div class="col-12 lg:col-6 custom-spacing-lright">
                    <div class="profile-rightbtn">

                        <div class="flex flex-column formgrid">
                            <label for="lastName">Last Name<span *ngIf="requiredLastNameAsterisk" class="custom-star">*</span></label>
                            <input pInputText placeholder="Enter Last Name" id="lastName" maxlength="50"
                                aria-describedby="username-help" formControlName="lastName"
                                (keydown)="dialogControlService.noNumbersValidator($event)" />
                            <div
                                *ngIf="managerForm.get('lastName')?.hasError('required')  && (managerForm.get('lastName')?.dirty || managerForm.get('lastName')?.touched)">
                                <div class="validation-error"> This field is required*</div>
                            </div>
                            <div
                                *ngIf="managerForm.get('lastName')?.hasError('minlength')  && (managerForm.get('lastName')?.dirty || managerForm.get('lastName')?.touched)">
                                <div class="validation-error"> Minimum 3 letters are required*</div>
                            </div>
                            <div
                                *ngIf="managerForm.get('lastName')?.hasError('leadingSpace')  && (managerForm.get('lastName')?.dirty || managerForm.get('lastName')?.touched)">
                                <div class="validation-error">Last Name cannot start with a space.*</div>
                            </div>
                            <div
                                *ngIf="managerForm.get('lastName')?.hasError('maxlength')  && (managerForm.get('lastName')?.dirty || managerForm.get('lastName')?.touched)">
                                <div class="validation-error"> Maximum 50 letters are required*</div>
                            </div>
                            <div
                                *ngIf="managerForm.get('lastName')?.hasError('pattern')  && (managerForm.get('lastName')?.dirty || managerForm.get('lastName')?.touched)">
                                <div class="validation-error"> Please enter only letters*</div>
                            </div>
                        </div>

                        <div class="flex flex-column formgrid">
                            <label htmlFor="password">Create Password<span class="custom-star">*</span></label>
                            <input pPassword [feedback]="false" maxlength="50" placeholder="Enter Password"
                                formControlName="password" />
                            <div class="validation-error"
                                *ngIf="managerForm.get('password')?.hasError('required') && (managerForm.get('password')?.dirty || managerForm.get('password')?.touched)">
                                <div class="validation-error">Field is required*</div>
                            </div>
                            <div
                                *ngIf="managerForm.get('password')?.hasError('minlength')  && (managerForm.get('password')?.dirty || managerForm.get('password')?.touched)">
                                <div class="validation-error">Minimum 8 characters are required*</div>
                            </div>
                        </div>
                        <div class="flex flex-column formgrid custom-status active-toggle">
                            <label>Status</label>
                            <label class="switch">
                                <input type="checkbox" />

                                <div class="slider round" (click)="managerStatus()">

                                    <span class="on">Active</span>
                                    <span class="off">Inactive</span>

                                </div>
                            </label>
                        </div>
</div>

                </div>
            </div>
            <div class="edit-outer">
                <p-button label="Submit" type="submit"></p-button>

            </div>
        </form>
    </div>
